import { all, call, put, takeLeading } from "redux-saga/effects";

import { defaultApi } from "../../utils/axiosApi";
import {
  DELETE_INTEGRATION,
  DELETE_INTEGRATION_FAILURE,
  DELETE_INTEGRATION_SUCCESS,
  REQUEST_INTEGRATIONS_OVERVIEW,
  REQUEST_INTEGRATIONS_OVERVIEW_FAILURE,
  REQUEST_INTEGRATIONS_OVERVIEW_SUCCESS,
  SAVE_INTEGRATION,
  SAVE_INTEGRATION_FAILURE,
  SAVE_INTEGRATION_SUCCESS,
} from "../../utils/constants";

const getErrorMessage = (error, fallback) =>
  error?.response?.data?.detail ||
  error?.response?.data?.message ||
  error?.response?.data?.error ||
  error?.message ||
  fallback;

export function* requestIntegrationsOverview() {
  try {
    const response = yield call(
      defaultApi,
      "integrations/overview/",
      "GET"
    );
    yield put({
      type: REQUEST_INTEGRATIONS_OVERVIEW_SUCCESS,
      payload: response?.data || {},
    });
  } catch (error) {
    yield put({
      type: REQUEST_INTEGRATIONS_OVERVIEW_FAILURE,
      payload: getErrorMessage(error, "Unable to load integrations."),
    });
  }
}

export function* saveIntegration({ payload }) {
  try {
    yield call(defaultApi, "integrations/new/", "POST", payload);
    yield put({
      type: SAVE_INTEGRATION_SUCCESS,
      payload: {
        providerKey: payload?.name,
        mutationType: "save",
      },
    });
    yield put({ type: REQUEST_INTEGRATIONS_OVERVIEW });
  } catch (error) {
    yield put({
      type: SAVE_INTEGRATION_FAILURE,
      payload: {
        providerKey: payload?.name,
        mutationType: "save",
        error: getErrorMessage(error, "Unable to save this integration."),
      },
    });
  }
}

export function* deleteIntegration({ payload }) {
  try {
    yield call(
      defaultApi,
      `integrations/${payload.connectionId}/`,
      "DELETE"
    );
    yield put({
      type: DELETE_INTEGRATION_SUCCESS,
      payload: {
        connectionId: payload.connectionId,
        providerKey: payload.providerKey,
        mutationType: "delete",
      },
    });
    yield put({ type: REQUEST_INTEGRATIONS_OVERVIEW });
  } catch (error) {
    yield put({
      type: DELETE_INTEGRATION_FAILURE,
      payload: {
        connectionId: payload.connectionId,
        providerKey: payload.providerKey,
        mutationType: "delete",
        error: getErrorMessage(error, "Unable to remove this integration."),
      },
    });
  }
}

export default function* integrationsSaga() {
  yield all([
    takeLeading(REQUEST_INTEGRATIONS_OVERVIEW, requestIntegrationsOverview),
    takeLeading(SAVE_INTEGRATION, saveIntegration),
    takeLeading(DELETE_INTEGRATION, deleteIntegration),
  ]);
}

